import {
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SHOW_MESSAGE,
  GET_CHATBOT_QUESTIONS,
} from '../../shared/constants/ActionTypes';
import jwtAxios from '@crema/services/auth/jwt-auth/jwt-api';

/** GET may return a bare array or `{ data, total, succeeded, message }`. */
const parseChatbotQuestionListResponse = (data) => {
  if (Array.isArray(data)) {
    return {list: data, total: data.length};
  }
  if (data && Array.isArray(data.data)) {
    return {
      list: data.data,
      total: typeof data.total === 'number' ? data.total : data.data.length,
    };
  }
  return {list: [], total: 0};
};

const getQuestionIdFromItem = (item) => {
  if (!item || typeof item !== 'object') {
    return undefined;
  }
  const raw =
    item.id ??
    item.Id ??
    item.chatbotQuestionId ??
    item.chatbotquestionId ??
    item.ChatbotQuestionId;
  if (raw == null || raw === '') {
    return undefined;
  }
  return String(raw);
};

const mapListItems = (rawList) => {
  const list = Array.isArray(rawList) ? rawList : [];
  return list.map((item) => {
    const id = getQuestionIdFromItem(item);
    return {
      ...item,
      id,
    };
  });
};

const isEnvelopeFailure = (data) =>
  data &&
  typeof data === 'object' &&
  !Array.isArray(data) &&
  data.succeeded === false;

export const getChatbotQuestions = () => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .get('/chatbotquestion')
      .then((res) => {
        if (res.status !== 200) {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Something went wrong, Please try again!',
          });
          return;
        }
        const payload = res.data;
        if (isEnvelopeFailure(payload)) {
          dispatch({
            type: FETCH_ERROR,
            payload:
              payload?.message || 'Something went wrong, Please try again!',
          });
          return;
        }
        dispatch({type: FETCH_SUCCESS});
        const {list, total} = parseChatbotQuestionListResponse(payload);
        dispatch({
          type: GET_CHATBOT_QUESTIONS,
          payload: {
            questions: mapListItems(list),
            total,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload:
            error?.response?.data?.message ??
            error?.response?.data?.msg ??
            error?.message,
        });
      });
  };
};

const isMutationSuccess = (res) => {
  if (res.status !== 200) {
    return false;
  }
  const d = res.data;
  if (d == null || typeof d !== 'object') {
    return true;
  }
  if (Array.isArray(d)) {
    return true;
  }
  if ('succeeded' in d) {
    return d.succeeded === true;
  }
  return true;
};

export const addChatbotQuestion = (body, onDone) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .post('/chatbotquestion', body)
      .then((res) => {
        if (isMutationSuccess(res)) {
          dispatch({type: FETCH_SUCCESS});
          if (res.data?.message) {
            dispatch({type: SHOW_MESSAGE, payload: res.data.message});
          }
          dispatch(getChatbotQuestions());
          onDone?.();
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload:
              res.data?.message || 'Something went wrong, Please try again!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload:
            error?.response?.data?.message ??
            error?.response?.data?.msg ??
            error?.message,
        });
      });
  };
};

/** Body: `{ id, title, order }` per API (id from GET list). */
export const updateChatbotQuestion = (body, onDone) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .put('/chatbotquestion', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        if (isMutationSuccess(res)) {
          dispatch({type: FETCH_SUCCESS});
          if (res.data?.message) {
            dispatch({type: SHOW_MESSAGE, payload: res.data.message});
          }
          dispatch(getChatbotQuestions());
          onDone?.();
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload:
              res.data?.message || 'Something went wrong, Please try again!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload:
            error?.response?.data?.message ??
            error?.response?.data?.msg ??
            error?.message,
        });
      });
  };
};

export const deleteChatbotQuestion = (chatbotquestionId) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .delete(`/chatbotquestion/${chatbotquestionId}`)
      .then((res) => {
        if (isMutationSuccess(res)) {
          dispatch({type: FETCH_SUCCESS});
          if (res.data?.message) {
            dispatch({type: SHOW_MESSAGE, payload: res.data.message});
          }
          dispatch(getChatbotQuestions());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload:
              res.data?.message || 'Something went wrong, Please try again!',
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload:
            error?.response?.data?.message ??
            error?.response?.data?.msg ??
            error?.message,
        });
      });
  };
};
